import { getEnvironmentVariable } from "./utils";
export const reactAppConfig = {
  baseUrl: getEnvironmentVariable("REACT_APP_BASE_URL"),
  googleMapUrl: getEnvironmentVariable("REACT_APP_GOOGLE_MAP_API"),
  scenarioManagerUrl: getEnvironmentVariable("REACT_APP_SCENARIO_MANAGER_URL"),
};
